import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Config from './Config';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const { api_url, app_url } = Config;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);
        if (!email.trim()) {
            setError('Please enter your email address');
            return;
        }
        setSubmitting(true);
        try {
            const formData = new FormData();
            formData.append('email', email.trim());
            formData.append('app_url', app_url);
            const response = await fetch(`${api_url}/ws-forgot-password`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();
            if (!response.ok || !data.success) {
                setError(data.message || 'Unable to process request');
                return;
            }
            setSuccess(data.message);
        } catch {
            setError('Unable to process request. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="login-body d-flex flex-column h-100">
            <div className="login-container">
                <div className="login-content">
                    <div className="login-content_header">
                        <span className="logo">
                            <img src="/assets/img/logo1.jpg" alt="Star Pacific Logo" />
                        </span>
                        <p>Forgot your password?</p>
                    </div>
                    <div style={{ float: 'left', width: '100%' }}>
                        <form className="login-form" onSubmit={handleSubmit}>
                            <input
                                type="email"
                                placeholder="Email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoComplete="email"
                            />
                            {error && <p className="text-danger">{error}</p>}
                            {success && <p className="text-success">{success}</p>}
                            <button type="submit" className="login-submit-btn" disabled={submitting}>
                                {submitting ? 'Sending...' : 'Send reset link'}
                            </button>
                        </form>
                        <div className="login-networks">
                            <p><Link to="/login">Back to login</Link></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
